import { BaseComponent } from '../../../../components/BaseComponent';
import PropTypes from 'prop-types';
import React from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import { compose } from 'redux';
import { createStructuredSelector } from 'reselect';
import styled from 'styled-components';
import { setNewInvoiceValue } from '../../actions';
import { selectNewInvoice, selectNewInvoiceValue } from '../../selectors';
import { Dropdown } from '../../../../components/Dropdown';
import { FormField } from '../../../../components/FormFields';
import { Input } from '../../../../components/Input';
import { Loader } from '../../../../components/Loader';
import { Row, Cell } from '../../../../components/List';
import { VehicleCreateField } from '../../../Vehicles/pages/create/AddVehicleModals/VehicleBaseModal/Fields';
import { VehicleCreateFieldCompanyUser } from '../../../Vehicles/pages/create/FieldCompanyUser';
import { Permission } from '../../../../components/Permission';
import {
  VEHICLE_DOCUMENTS_CRUD,
  PURCHASING_DATA_CRUD,
  VEHICLE_EXTRA_COSTS_CRUD,
  COMPANY_EDIT_BTW_NUMBER,
  COMPANY_EDIT_IBAN,
  COMPANY_EDIT_CUSTOMERNUMBER,
  EDIT_VEHICLE_STATUS,
  INVOICE_CRUD,
  INVOICE_EDIT,
  EDIT_COMPANY_STATUS,
  COMPANY_DOCUMENTS_CRUD,
  COMPANY_EDIT_COMPANY_FROM_EU,
} from '../../../../components/Permission/constants';

import { BTW_COUNTRIES } from '../../../Companies/constants';
import { HBox, VBox } from '../../../../components/Box';
import { IbanField } from '../../../Companies/components/IbanField';
import { INVOICE_DIRECTIONS } from '../../constants';
import styles from './FieldsCreditor.module.css';

const DROPDOWN_OPTIONS = {
  // company_from_eu: ['NL', 'EU', 'OUTSIDE_EU'],
};

const STATE = {
  value: '',
};

const RequireMark = styled.span`
  margin-left: 4 px;
  font-size: 24px;
  color: red;
`;

const LabelWrapper = styled.div`
  white-space: nowrap;
`;

const DropdownWrapper = styled.div`
  .dropdown-BTW {
    > .Dropdown-root {
      min-width: 60px;

      > .Dropdown-menu {
        min-width: 130px;
      }
    }
  }
`;

const InputCardWrapper = styled.div`
  .input-card-wrapper {
    > .form-controlField .decorated input {
      max-width: 150px;
    }
  }
`;

/* eslint-disable react/prefer-stateless-function */
class CreditorFieldComp extends BaseComponent {
  constructor(props) {
    super(props, { ...STATE });
  }

  componentDidMount() {
    if (!this.props.value || this.props.values?.id != this.props.match.params?.id) {
      this.props.type !== 'financial_contact' &&
        this.targetCompany &&
        this.props.setValue(this.targetCompany[this.props.type], this.props.type);
    }
  }

  get targetCompany() {
    const company =
      this.props.invoice?.direction == INVOICE_DIRECTIONS.INCOMING
        ? this.props.invoice?.incomingCompany
        : this.props.invoice?.outgoingCompany;
    return company;
  }

  get btwNumberInputValue() {
    if (this.props.type !== 'BTW_number') return;
    let options = BTW_COUNTRIES.map(c => ({ value: c.code, label: `${c.code}-${c.country}` }));
    const isWithCode = options.find(o => this.props.value?.includes(o.value));
    if (isWithCode) {
      return this.props.value?.substring(2);
    }
    return this.props.value || '';
  }

  isDropbox() {
    return this.props.type in DROPDOWN_OPTIONS;
  }

  wrap(children) {
    switch (this.props.type) {
      default:
        return (
          <Row key={this.props.type}>
            <Cell>{this.formFieldLabel()}</Cell>
            <Cell>
              <FormField>{children}</FormField>
            </Cell>
          </Row>
        );
    }
  }

  formFieldLabel() {
    return <LabelWrapper>{this.lbl(`company.property.${this.props.type}`)}</LabelWrapper>;
  }

  dropdown() {
    const vals = DROPDOWN_OPTIONS[this.props.type];

    const options = vals.map(val => ({
      label: this.lbl(`vehicle.property.${this.props.type}.${val}`),
      value: val,
    }));

    const value = options.find(o => o.value == this.props.value);

    return (
      <>
        <Dropdown options={options} value={value} onChange={pair => this.props.setValue(pair.value)} />
        {this.requireMessage && !this.props.value ? <RequireMark>*</RequireMark> : null}
      </>
    );
  }

  btwDropdown() {
    let options = BTW_COUNTRIES.map(c => ({ value: c.code, label: `${c.code}-${c.country}` }));
    let value = options.find(o => this.props.value?.includes(o.value));
    const selected = { label: value?.value };
    return (
      <div className={styles.container}>
        <Dropdown
          className={styles.dropdown}
          options={options}
          value={selected}
          onChange={pair => {
            if (value?.value) {
              this.props.setValue(`${pair.value}${this.props.values?.BTW_number?.substring(2)}`, 'BTW_number');
              return;
            }
            return this.props.setValue(`${pair.value}${this.props.values?.BTW_number}`, 'BTW_number');
          }}
        />
      </div>
    );
  }

  reset() {
    this.setState({ ...STATE });
  }

  get requireMessage() {
    return this.props.isRequire?.includes(this.props.type);
  }

  render() {
    if (this.props.work) return <Loader small />;
    return <>{this.wrap(this.renderField())}</>;
  }

  renderField() {
    if (this.isDropbox()) {
      return this.dropdown();
    }

    switch (this.props.type) {
      case 'financial_contact':
        return (
          <VehicleCreateFieldCompanyUser
            selectedCreditorId={this.props.value}
            companyId={this.targetCompany?.id}
            key={`${this.props.type}-${this.props.values.creditor_company}`}
            type={this.props.type}
            onChange={value => this.props.setValue(value)}
          />
        );
      case 'IBAN':
        return (
          <InputCardWrapper>
            <HBox vCenter className="input-card-wrapper">
              <Permission permission={COMPANY_EDIT_IBAN} proxy={this.props.value ?? '-'}>
                <IbanField
                  setIban={value => this.props.setValue(value?.replace(/\s/g, ''), 'IBAN')}
                  incomingInvoice
                  small
                  cardWidth={{ maxWidth: '115px' }}
                  className="input-card-wrapper"
                  company={this.targetCompany}
                  key={'IBAN'}
                  value={this.props.value}
                  type={'IBAN'}
                />
              </Permission>
            </HBox>
          </InputCardWrapper>
        );

      case 'BTW_number':
        return (
          <VBox vCenter>
            <Permission permission={COMPANY_EDIT_BTW_NUMBER} proxy={this.props.value ?? '-'}>
              {this.btwDropdown()}
              <input
                className="form-control"
                name="BTW_number"
                value={this.btwNumberInputValue}
                onChange={evt => {
                  let options = BTW_COUNTRIES.map(c => ({ value: c.code, label: `${c.code}-${c.country}` }));
                  const isWithCode = options.find(o => this.props.value?.includes(o.value));
                  if (isWithCode?.value) {
                    this.props.setValue(`${isWithCode?.value}${evt.target.value}`);
                    return;
                  }
                  this.props.setValue(evt.target.value);
                }}
              />
            </Permission>
          </VBox>
        );
      case 'customernumber':
        return (
          <Permission permission={COMPANY_EDIT_CUSTOMERNUMBER} proxy={this.props.value ?? '-'}>
            <input
              className="form-control"
              name="customernumber"
              value={this.props.value || ''}
              onChange={evt => this.props.setValue(evt.target.value)}
            />
            {this.requireMessage && !this.props.value ? <RequireMark>*</RequireMark> : null}
          </Permission>
        );
      case 'company_from_eu':
        return (
          <Permission permission={COMPANY_EDIT_COMPANY_FROM_EU} proxy={this.props.value ?? '-'}>
            <input
              className="form-control"
              disabled={true}
              name="company_from_eu"
              value={this.props.value || ''}
              onChange={evt => this.props.setValue(evt.target.value)}
            />
            {this.requireMessage && !this.props.value ? <RequireMark>*</RequireMark> : null}
          </Permission>
        );
    }
  }
}

CreditorFieldComp.propTypes = {
  dispatch: PropTypes.func.isRequired,
};

const mapStateToProps = (state, ownProps) =>
  createStructuredSelector({
    value: selectNewInvoiceValue(ownProps.type),
    values: selectNewInvoice(),
  });

function mapDispatchToProps(dispatch, ownProps) {
  return {
    dispatch,
    setValue(value, name = null) {
      name = name ?? ownProps.type;
      dispatch(setNewInvoiceValue(name, value));
    },
  };
}

const withConnect = connect(mapStateToProps, mapDispatchToProps);

export const CreditorField = compose(withConnect, withRouter)(CreditorFieldComp);
